import { Component, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { decrypt } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ProjectScenarioConfigDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-configuration/project-scenario-config-data-grid.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, of, finalize } from 'rxjs';

@Component({
  selector: 'piqet-angular-add-packaging-content-configuration',
  templateUrl: './add-packaging-content-configuration.component.html',
  styleUrls: ['./add-packaging-content-configuration.component.css'],
})
export class AddPackagingContentConfigurationComponent {
  reportConfigForm!: FormGroup;
  contentList: any;
  massList: any;
  funcUnitList: any;
  reportConfigData: any;
  submitted: boolean = false;
  packageScenarioId: any;
  scenarioId: any;
  detailData: any;
  productId: any;
  selectedProduct: any;

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    public route: ActivatedRoute,
    private projectService: ProjectsService,
    private toaster: ToastrService,
    private projectScenarioConfigDataGridService: ProjectScenarioConfigDataGridService
  ) {
    this.reportConfigData =
      this.modal?.modalService?.config?.initialState?.['packagingContentData'];

    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.packageScenarioId = value['packageScenarioId'];
    });
  }

  ngOnInit() {
    this.reportConfigForm = this.formBuilder.group({
      contents: [null, Validators.required],
      mass: [],
      funcUnit: [null, Validators.required],
    });
    this.getProduct();
    this.setFormValue();
  }

  setFormValue() {
    this.reportConfigForm.patchValue({
      contents: this.selectedProduct,
      funcUnit: this.reportConfigData?.functionalUnitsPerProduct,
      mass: this.reportConfigData?.massOfProductInGram,
    });
  }

  onClose() {
    this.modal.close();
  }

  async selectedPackage(eve: any) {
    if (eve?.idStr) {
      this.detailData = (
        await this.projectService.getPackagingContentDetail(Number(eve?.idStr))
      )?.data;
      this.productId = Number(eve?.idStr);
      this.reportConfigForm.patchValue({ mass: this.detailData?.massOfProductInGram });
    }
  }

  async getProduct() {
    await this.reportConfigData?.productList?.map((item: any) => {
      if (item.idStr == this.reportConfigData?.productId) {
        return (this.selectedProduct = item);
      }
    });
  }

  onSave() {
    this.submitted = true;
    if (this.reportConfigForm.valid && this.reportConfigForm.controls['funcUnit'].value > 0) {
      this.submitted = false;
      const payload = {
        id: this.reportConfigData?.id || 0,
        packageScenarioId: this.scenarioId,
        massOfProductInGram:
          this.reportConfigForm.controls['mass'].value ||
          this.reportConfigData?.massOfProductInGram,
        scenarioId: this.packageScenarioId,
        functionalUnitsPerProduct:
          this.reportConfigForm.controls['funcUnit'].value ||
          this.reportConfigData?.functionalUnitsPerProduct,
        productId: this.productId || this.reportConfigData?.productId,
      };
      this.addUpdatePackagingContent(payload);
    }
  }

  addUpdatePackagingContent(data: any) {
    this.projectService
      .addEditPackagingContentConfig(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.projectScenarioConfigDataGridService.getScenarioDetailList();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }
}
